export default "__VITE_ASSET__23e6fac2__"